import { Radio } from 'antd';
import backgroundConfig from '@utils/backgroundConfig';
import { cn } from '@utils/utils';

const isImg = ['recommend'];
const isPattern = ['texture'];

// 纹理背景的前缀列表
const texturePatterns = ['basic_', 'geo_', 'line_', 'dark_', 'colorful_', 'texture_gradient_', 'theme_'];

// 检查是否为网络URL
const isUrl = (str) => {
    return typeof str === 'string' && (str.startsWith('http://') || str.startsWith('https://'));
};

// 检查是否为CSS类名
const isCssClass = (str) => {
    return typeof str === 'string' && str.startsWith('bg-');
};

export const BackgroundSelect = ({ type, options, onChange, value }) => {
    let lists = [];
    if (options && options.length) {
        lists = options;
    } else {
        const arr = [];
        Object.keys(backgroundConfig).map((key) => {
            if (type === 'texture') {
                // 如果当前类型是 texture，检查 key 是否以纹理背景前缀开头
                if (texturePatterns.some(pattern => key.startsWith(pattern))) {
                    arr.push({
                        key,
                        value: backgroundConfig[key],
                    });
                }
            } else if (type === 'gradient') {
                // 如果当前类型是 gradient，仅检查 key 是否以 gradient_ 开头，不要包括纹理渐变
                if (key.startsWith('gradient_') && !texturePatterns.some(pattern => key.startsWith(pattern))) {
                    arr.push({
                        key,
                        value: backgroundConfig[key],
                    });
                }
            } else if (key.includes(type)) {
                arr.push({
                    key,
                    value: backgroundConfig[key],
                });
            }
        });
        lists = arr;
    }

    // 获取图片源
    const getImageSrc = (item) => {
        const classValue = item.value.class;
        
        // 判断是URL、导入的图片对象还是CSS类
        if (isUrl(classValue)) {
            return `${classValue}&w=48`; // 网络URL，添加宽度参数
        } else if (typeof classValue === 'string' && classValue.startsWith('@assets')) {
            return item.value.fill.url; // 本地路径字符串
        } else {
            return classValue; // 导入的图片对象或其他情况
        }
    };

    return (
        <Radio.Group
            onChange={(e) => onChange(e.target.value)}
            value={value}
            rootClassName={cn(
                'grid [&_span]:ps-0',
                isImg.includes(type) ? 'grid-cols-5 gap-y-1.5' : 'grid-cols-7 gap-y-3'
            )}
        >
            {lists.map((item, index) => (
                <Radio
                    key={index}
                    className='[&_.ant-radio]:hidden [&_span]:p-0 mr-0'
                    value={item.key}
                >
                    {isImg.includes(type) ? (
                        <div className={cn('w-12 h-8 rounded-md overflow-hidden')}>
                            <img 
                                src={getImageSrc(item)} 
                                className='w-full h-full object-cover object-center' 
                            />
                        </div>
                    ) : isPattern.includes(type) || texturePatterns.some(pattern => item.key.startsWith(pattern)) ? (
                        <div 
                            className={cn('w-8 h-8 rounded-full overflow-hidden', isCssClass(item.value.class) ? item.value.class : '')}
                            style={{
                                backgroundImage: `url(${item.value.fill.url})`,
                                backgroundColor: item.value.fill.backgroundColor || '#ffffff',
                                backgroundSize: `${item.value.fill.width || 20}px ${item.value.fill.height || 20}px`,
                                backgroundRepeat: 'repeat'
                            }}
                        ></div>
                    ) : (
                        <div className={cn('w-8 h-8 rounded-full overflow-hidden', isCssClass(item.value.class) ? item.value.class : '')}></div>
                    )}
                </Radio>
            ))}
        </Radio.Group>
    );
};
